import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const SeatingCapacity = ({ onSeatingCapacitySelected }) => {
  const [selectedSeatingCapacity, setSelectedSeatingCapacity] = useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.seatingcapacity) {
        const seatingCapacityObject = firstResult.seatingcapacity;
        if (seatingCapacityObject.trim() !== "") {
          setVariations(seatingCapacityObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleSeatingCapacityClick = (seatingcapacity) => {
    setSelectedSeatingCapacity(seatingcapacity);
    onSeatingCapacitySelected(seatingcapacity);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Seating Capacity:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedSeatingCapacity === variation ? "selected" : ""}`}
            onClick={() => handleSeatingCapacityClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default SeatingCapacity;
